<div class="modal-dialog" role="document">
    <div class="modal-content">
        <div class="modal-header">
            <h2 class="modal-title" translate>LABEL.BASIC_AUTHENTICATION </h2>
            <button type="button" class="btn-close" (click)="close(false)" data-bs-dismiss="modal"
                    aria-label="Close"></button>
        </div>
        <form name="authForm" #tplForm="ngForm">
            <div class="modal-body">
                <div class="form-floating field">
                    <input
                        id="basicAuthEmail"
                        type="email"
                        class="form-control"
                        placeholder="name@example.com"
                        ngModel
                        name="basicAuthEmail"
                    />
                    <label for="basicAuthEmail" translate>LABEL.EMAIL</label>
                    <validation-error class="invalid-feedback" for="basicAuthEmail"/>
                </div>
                <div class="input-group field">
                    <div class="form-floating">
                        <input
                            id="basicAuthPassword"
                            [type]="showPassword ? 'text' : 'password'"
                            autocomplete="current-password"
                            class="form-control"
                            placeholder="Password"
                            ngModel
                            name="basicAuthPassword"
                        />
                        <label for="basicAuthPassword" translate>LABEL.PASSWORD</label>
                        <validation-error class="invalid-feedback" for="basicAuthPassword"/>
                    </div>
                    <button class="btn btn-outline-secondary" type="button" (click)="showPassword = !showPassword">
                        <app-sprite-image [assetId]="showPassword ? 'portal-eye' : 'portal-eye-slash'"/>
                    </button>
                </div>
            </div>
            <div class="modal-footer justify-content-center">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="close(false)">Cancel
                </button>
                <button class="btn btn-primary"
                        data-bs-dismiss="modal"
                        type="submit"
                        (onValid)="submit($event)"
                        [disabled]="tplForm.disabled"
                        translate
                >BUTTON.CONTINUE
                </button>
            </div>
        </form>

    </div>
</div>
